import { getRegisterSgagri } from '../../../../Services/registerSgagri'

//Função que traz os dados do banco de dados
export const get = () =>{
    return[
        
        (dispatch,getState)=>{
        const order = getState().register_sgagri.order
        const th = getState().register_sgagri.th
        const qtd_per_page = getState().register_sgagri.qtd_per_page
        const pesquisa = getState().register_sgagri.pesquisa || ''
        // const id_coordinator = getState().register_sgagri.coordinator_report.value || ''
        const id_status = getState().register_sgagri.status_report.value || ''
        // const area_report = getState().register_sgagri.area_report.value || ''
        const project_report = getState().register_sgagri.project_report.value || ''
        const from = getState().register_sgagri.from
        const to = getState().register_sgagri.to 
        const page = getState().register_sgagri.page     
      
        getRegisterSgagri(page,qtd_per_page,order,th,pesquisa,project_report,id_status,from,to)
        .then(resp=>dispatch({type:'RegisterSgagri', payload:resp.data}))

    }]
}

//Função que ordena as colunas
export const order = (coluna) => {
    return [(dispatch,getState)=>{
        const asc = getState().register_sgagri.asc
      
        if(asc === true){
            dispatch({type:'GetRegisterSgagri_Desc', desc:true, asc:false,order:'desc',th:coluna})
            
        }if(asc === false){
            dispatch({type:'GetRegisterSgagri_Asc', asc:true, desc:false,order:'asc',th:coluna})
            
        }
     
    },get(1)]    
}

export const change_qtd_per_page = event => {
    return[{
        type:'qtd_per_page_RegisterSgagri',
        payload:event.target.value
    },get(1)]
}

export const changePesquisa = event => {
    return[{
        type:'pesquisaRegisterSgagri',
        payload:event.target.value
    }]
}

export const clearPesquisa = event => {
    return[(dispatch, getState) =>{
        const fromFix = getState().register_sgagri.fromFix
        const toFix = getState().register_sgagri.toFix
        dispatch({
            type:'clearPesquisaRegisterSgagri',
            payload:'',
            coordinator_report: '',
            area_report: '' , 
            status_report: '',
            from: fromFix ,
            to: toFix,
            project_report: ''       
        })
    },get(1)]
}


export const changePage = page => {
    return[{
        type: 'changePageRegisterSgagri',
        payload: page
    },get()]
}

export const search = () => {
    return [
        (dispatch, getState) => {
            const pesquisa = getState().register_sgagri.pesquisa || ''
            const id_coordinator = getState().register_sgagri.coordinator_report.value || ''
            const id_status = getState().register_sgagri.status_report.value || ''
            const from = getState().register_sgagri.from
            const to = getState().register_sgagri.to 
            if(pesquisa || id_coordinator || id_status || from || to){
                return dispatch({type:'changePageRegisterSgagri', payload:1})
            }
        }, get()
    ]
}